import styled from "styled-components";

export const MessageTypeFilter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 20rem;
  padding-top: 2.5rem;
`;
